/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Suspended_BodyInputs */



/**
* | output |
* | --- |
* | "Access has been paused. Your data has not been deleted and will be available again once the suspension is lifted." |
*
* @param {Org_Suspended_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_suspended_body = /** @type {((inputs?: Org_Suspended_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Suspended_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Zugriff wurde ausgesetzt. Ihre Daten wurden nicht gelöscht und stehen wieder zur Verfügung, sobald die Sperre aufgehoben wird.")
	return /** @type {LocalizedString} */ ("Access has been paused. Your data has not been deleted and will be available again once the suspension is lifted.")
});